// extracted by mini-css-extract-plugin
export default {"link":"BrandLogoLink_link__fR6Iu","logo":"BrandLogoLink_logo__9j3XE"};